module.exports = __webpack_public_path__ + "img/main_bg_bottom.7adb77f2.jpg";